import { PDFViewer } from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
import ImprimirPDF from './ImprimirPDFAntecedentes'
import { useParams } from 'react-router-dom'
import {Spinner} from "asocomponents"
import AntecedentesSiniestralesServices from '../../../../modules/AntecedentesSiniestrales/application/AntecedentesSiniestralesServices'

export default function VisorAntecedentes() {

  const {idDenuncia} = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [datosAntecedentes, setDatosAntecedentes] = useState({})
  //#endregion

    //#region funciones

  const cargarDatosAntecedentes = async (idDenuncia) => {
    const antecedenteService = new AntecedentesSiniestralesServices()
    const resultAntecedentes = await antecedenteService.obtenerDatosAntecedentes(idDenuncia)
    setDatosAntecedentes(resultAntecedentes)

  }
  //#endregion

  //#region useEffect
  useEffect(() => {
    const cargarDatos = async () => {
      setIsLoading(true)
      await cargarDatosAntecedentes(idDenuncia)
      setIsLoading(false)
    };
  
    cargarDatos()
  }, [])

  //#endregion

  if (isLoading) {
    return <Spinner color="red" size="50" />
  }

  return (
    <div id='root'>
        <PDFViewer width={900} height={700}>
          <ImprimirPDF datosImpresion={datosAntecedentes}/>
        </PDFViewer>
    </div>
  )
}
